import gql from "graphql-tag";

export default function query(params) {

    return gql`
        mutation {
            deleteSaltoGateway(
                id: "${params.id}"
            ) {
                errors
            }
        }`;
}
